import { NavLink } from "react-router-dom";
import { FiEye, FiTrash2 } from "react-icons/fi";
import Delete from "../Modals/delete";
import ConfirmEmailSend from "../Modals/send-email-cart-funnel";
import { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { deleteCartFunnel } from "../../stores/actions/cart-funnel.actions.types";

const CartFunnelTable = ({ cartFunnels, deleteCartFunnel, setCartFunnels }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [funnelId, setFunnelId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDelete = async () => {
    setDeleteLoading(true);

    const callback = (data) => {
      if (data.success) {
        setCartFunnels((prev) => prev.filter((item) => item._id !== funnelId));
        setDeleteLoading(false);
        setIsModalOpen(false);
      } else {
        setDeleteLoading(false);
      }
    };

    deleteCartFunnel({ id: funnelId, callback });
  };

  const handleDeleteClick = (id) => {
    setFunnelId(id);
    setIsModalOpen(true);
  };

  return (
    <div className='rounded-[10px] bg-white drop-shadow-1 border-l border-slate-300 dark:border-slate-700 dark:bg-boxdark dark:drop-shadow-none border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-gray-dark dark:shadow-card sm:p-2.5 transition-colors duration-300'>
      <div className='max-w-full overflow-x-auto overflow-y-hidden pb-6'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left dark:bg-dark-2'>
              <th className='min-w-[220px] px-4 py-2 font-medium text-dark dark:text-white xl:pl-7.5'>
                Customer Email
              </th>
              <th className='min-w-[160px] px-4 py-2 font-medium text-dark dark:text-white'>
                Email Sent
              </th>
              <th className='min-w-[200px] px-4 py-2 font-medium text-dark dark:text-white'>
                Created Time
              </th>
              <th className='min-w-[120px] px-4 py-2 text-right font-medium text-dark dark:text-white xl:pr-7.5'>
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {cartFunnels.map((funnel, index) => (
              <tr key={funnel?._id} className='text-sm'>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pl-7.5 ${
                    index === cartFunnels.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {funnel?.email}
                  </span>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === cartFunnels.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {funnel?.emailSentCount}
                  </span>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === cartFunnels.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {moment(funnel?.updatedAt || funnel?.createdAt).format(
                      "D MMM YYYY, hh:mm A"
                    )}
                  </span>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === cartFunnels.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <div className='flex items-center justify-end space-x-3.5'>
                    {/* View button */}
                    <div className='group relative'>
                      <NavLink to={`/cart-funnels/details/${funnel?._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEye className='text-lg' />
                        </button>
                      </NavLink>
                      <span className='absolute left-1/2 top-full w-[60px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white'>
                        Details
                      </span>
                    </div>

                    {/* Delete button */}
                    <div className='group relative'>
                      <button
                        className='mt-[7px] hover:text-primary'
                        onClick={() => handleDeleteClick(funnel?._id)}
                      >
                        <FiTrash2 className='text-lg' />
                      </button>
                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-white dark:text-gray-700'>
                        Delete
                      </span>
                    </div>

                    <Delete
                      opened={isModalOpen}
                      setOpend={setIsModalOpen}
                      title='Delete Cart Funnel'
                      handleDelete={handleDelete}
                      loading={deleteLoading}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { deleteCartFunnel })(CartFunnelTable);
